
/**
 * @nullable
 */
export type GetApiCourses200ContentItemLevel = typeof GetApiCourses200ContentItemLevel[keyof typeof GetApiCourses200ContentItemLevel] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCourses200ContentItemLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
